import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_ADD_LAB_RESEARCH_ORDER')